var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 57,
    viewBox: "0 0 64 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 28.5,
    rx: 32,
    ry: 28.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 13C24.75 13 18 19.762 18 28.0904C18 35.6205 23.49 41.8705 30.66 43V32.4578H26.85V28.0904H30.66V24.762C30.66 20.9819 32.895 18.9036 36.33 18.9036C37.965 18.9036 39.675 19.1898 39.675 19.1898V22.9096H37.785C35.925 22.9096 35.34 24.0693 35.34 25.259V28.0904H39.51L38.835 32.4578H35.34V43C38.8746 42.4395 42.0933 40.6288 44.4149 37.8947C46.7364 35.1606 48.008 31.6832 48 28.0904C48 19.762 41.25 13 33 13Z",
    fill: "#3FAEFD",
    fillOpacity: 0.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.48d4998ea031fd580a7d3fbb4ea3ba05.svg";
export { ForwardRef as ReactComponent };